<router-outlet></router-outlet>
<ngx-spinner size="large" type="ball-fussion"></ngx-spinner>